import React from 'react';
import { cn } from '~/helpers/utils';

type StatsCardProps = {
  imageLink: string;
  stat: string;
  text: string;
  alt?: string;
  containerClassName?: string;
  imageClassName?: string;
  contentClassName?: string;
  titleClassName?: string;
  statClassName?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({ 
  imageLink, 
  stat, 
  text, 
  alt, 
  containerClassName,
  imageClassName,
  contentClassName,
  titleClassName,
  statClassName,
}) => {
  return (
    <div className={cn('flex flex-col xl:flex-row items-center justify-center', containerClassName)}>
      <img
        src={imageLink}
        alt={alt || ''}
        className={cn('w-7 md:w-10 lg:w-12 xl:w-16 md:ml-0 mb-2 xl:mb-0', imageClassName)}
      />
      <div className={cn('w-full text-center xl:text-left px-4', contentClassName)}>
        <span className={cn('block font-black text-base sm:text-xl md:text-2xl lg:text-3xl text-black', titleClassName)}>{stat}</span>
        <span className={cn('block text-blue-600 font-bold text-xs sm:text-sm lg:text-base xl:max-w-40', statClassName)}>{text}</span>
      </div>
    </div>
  );
};

export default StatsCard;